// Motore superfici: ambienti interni e aree esterne. Nessuna misura precompilata.

export const emptyInternal = () => ({
  length: 0,
  width: 0,
  height: 0,
  subtractOpenings: false,
  doors: 0,
  doorW: 0,
  doorH: 0,
  windows: 0,
  winW: 0,
  winH: 0,
  overrideFloor: "",
  overrideWalls: "",
  overridePerimeter: "",
});

export const emptyExternal = () => ({
  length: 0,
  width: 0,
  hasVerticals: false,
  verticals: [],
  overrideArea: "",
  overridePerimeter: "",
  overrideVertical: "",
});

export const emptyVertical = (type = "Parete") => ({
  id: `v-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  type,
  length: 0,
  height: 0,
});

const num = (v) => Math.max(0, Number(v) || 0);
const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const used = (v) => v !== "" && v !== null && v !== undefined;

export const zoneSurfaces = (zone) => {
  const d = zone.dims || {};
  if (zone.kind === "external") {
    const areaAuto = num(d.length) * num(d.width);
    const perimAuto = 2 * (num(d.length) + num(d.width));
    const vertAuto = (d.verticals || []).reduce((s, v) => s + num(v.length) * num(v.height), 0);
    return {
      kind: "external",
      floor: 0,
      ceiling: 0,
      walls: 0,
      wallsGross: 0,
      openings: 0,
      height: 0,
      area: r2(used(d.overrideArea) ? num(d.overrideArea) : areaAuto),
      perimeter: r2(used(d.overridePerimeter) ? num(d.overridePerimeter) : perimAuto),
      vertical: r2(used(d.overrideVertical) ? num(d.overrideVertical) : vertAuto),
      segments: [num(d.length), num(d.width), num(d.length), num(d.width)],
      manual: {
        area: used(d.overrideArea),
        perimeter: used(d.overridePerimeter),
        vertical: used(d.overrideVertical),
      },
    };
  }

  const h = num(d.height);
  const floorAuto = num(d.length) * num(d.width);
  const perimAuto = 2 * (num(d.length) + num(d.width));
  const perimeter = used(d.overridePerimeter) ? num(d.overridePerimeter) : perimAuto;
  const wallsGross = perimeter * h;
  const openings = d.subtractOpenings
    ? num(d.doors) * num(d.doorW) * num(d.doorH) + num(d.windows) * num(d.winW) * num(d.winH)
    : 0;
  const wallsAuto = Math.max(0, wallsGross - openings);
  const floor = used(d.overrideFloor) ? num(d.overrideFloor) : floorAuto;
  const walls = used(d.overrideWalls) ? num(d.overrideWalls) : wallsAuto;

  return {
    kind: "internal",
    height: h,
    floor: r2(floor),
    ceiling: r2(floor),
    perimeter: r2(perimeter),
    wallsGross: r2(wallsGross),
    openings: r2(openings),
    walls: r2(walls),
    area: r2(floor),
    vertical: 0,
    segments: [num(d.length), num(d.width), num(d.length), num(d.width)],
    manual: {
      floor: used(d.overrideFloor),
      walls: used(d.overrideWalls),
      perimeter: used(d.overridePerimeter),
    },
  };
};

// Basi quantità gestite da admin
export const BASIS_OPTIONS = [
  ["floor", "m² pavimento"],
  ["ceiling", "m² soffitto"],
  ["walls", "m² pareti interne"],
  ["vertical", "m² superficie verticale"],
  ["area", "m² area esterna"],
  ["perimeter", "ml perimetro"],
  ["none", "quantità manuale"],
];

export const basisLabel = (b) => (BASIS_OPTIONS.find(([k]) => k === b) || [, ""])[1];

// Basi che richiedono superfici verticali/pareti
export const isWallBasis = (b) => b === "walls" || b === "vertical";

export const itemQty = (item, surf, cfg = {}) => {
  const basis = item.surface_basis || "none";
  if (basis === "none") return num(cfg.qty ?? 1);
  if (basis === "floor") return surf.kind === "external" ? surf.area : surf.floor;
  if (basis === "area") return surf.kind === "external" ? surf.area : surf.floor;
  if (basis === "ceiling") return surf.ceiling;
  if (basis === "perimeter") return surf.perimeter;

  if (basis === "walls" || basis === "vertical") {
    const total = basis === "walls" ? surf.walls : surf.vertical;
    const mode = cfg.wallMode || "all";
    if (mode === "custom") return num(cfg.customArea);
    if (basis === "vertical") return total;
    const h = cfg.wallHeight === undefined || cfg.wallHeight === "" ? surf.height : num(cfg.wallHeight);
    const fullHeight = surf.height > 0 && Math.abs(h - surf.height) < 0.001;
    if (mode === "all") {
      if (fullHeight || surf.height === 0) return total;
      return r2(total * (h / surf.height));
    }
    const n = Math.min(4, Math.max(1, parseInt(mode, 10) || 1));
    const linear = surf.segments.slice(0, n).reduce((s, l) => s + l, 0);
    const scale = surf.wallsGross > 0 ? surf.walls / surf.wallsGross : 1;
    return r2(linear * h * scale);
  }
  return num(cfg.qty ?? 1);
};

export const UNIT_LABEL = {
  m2: "m²",
  ml: "ml",
  pz: "pz",
  ora: "ora",
  corpo: "a corpo",
  viaggio: "viaggio",
  m3: "m³",
  giorno: "giorno",
};

export const VAT_OPTIONS = [
  { value: 0, label: "0% / Esente" },
  { value: 4, label: "IVA 4%" },
  { value: 10, label: "IVA 10%" },
  { value: 22, label: "IVA 22%" },
];
